import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, Form, Input, InputNumber, Row } from 'antd';
import { GetById_PeriodLimitation_Api, Update_PeriodLimitation_Api } from '../../API/PeriodLimitationApi'; 
import { AllCategoryComponent } from '../Category/AllCategoryComponent'; 
import { RollbackOutlined, CheckOutlined } from '@ant-design/icons';

// -----------------------------------------------------------
// وارد کردن DatePicker و تنظیمات شمسی (رفع مشکل کبیسه و فرمت)
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// -----------------------------------------------------------


// =================================================================
const SERVER_DATE_FORMAT = "YYYY-MM-DD"; 

/**
 * تابع کمکی برای تبدیل ارقام فارسی (و عربی) در یک رشته به ارقام انگلیسی/لاتین،
 * و تبدیل اسلش به خط تیره برای فرمت سرور (YYYY-MM-DD).
 */
const persianToEnglishNumbers = (str) => {
    if (!str) return '';
    let output = String(str).trim(); 

    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let i = 0; i < 10; i++) {
        output = output.replace(persianNumbers[i], englishNumbers[i]);
        output = output.replace(arabicNumbers[i], englishNumbers[i]);
    }

    return output.replace(/\//g, "-"); 
};

// =================================================================
const PersianDatePickerAdapter = ({ value, onChange }) => {
    const [dateValue, setDateValue] = useState(null);

    const toDateObject = (dateString) => {
        if (!dateString) return null;
        const englishDateString = persianToEnglishNumbers(dateString); 
        
        return new DateObject({
            calendar: persian,
            locale: persian_fa,
            date: englishDateString,
            format: SERVER_DATE_FORMAT 
        });
    };
    
    useEffect(() => {
        // این کار مقدار اولیه بارگذاری شده از سرور را به DatePicker می‌دهد
        setDateValue(toDateObject(value));
    }, [value]);

    const handleOnChange = (dateObject) => {
        setDateValue(dateObject); 

        let dateString = null;
        if (dateObject) {
            const persianDateString = Array.isArray(dateObject) ? 
                         dateObject.map(d => d.format(SERVER_DATE_FORMAT)) : 
                         dateObject.format(SERVER_DATE_FORMAT);
            dateString = persianToEnglishNumbers(persianDateString);
        }
        
        // ارسال مقدار رشته‌ای تمیز و انگلیسی (با خط تیره) به Form.Item
        onChange(dateString);
    };

    return (
        <DatePicker
            calendar={persian}
            locale={persian_fa}
            value={dateValue}
            onChange={handleOnChange}
            inputClass="ant-input persian-date-input" 
            calendarPosition="bottom-right"
            format={SERVER_DATE_FORMAT} 
        />
    );
};

// ======================================================================
export const EditPeriodLimitationComponent = ({ setLoading, showMessage, id, rowUpdated, cancelEdit }) => {
    // ======================================================================
    const [periodLimitation, setPeriodLimitation] = useState();
    const [categoryId, setCategoryId] = useState(-1);
    
    // State ها برای نگهداری مقادیر تاریخ اولیه بارگذاری شده از سرور
    const [initialFromDate, setInitialFromDate] = useState(null);
    const [initialToDate, setInitialToDate] = useState(null);

    const [form] = Form.useForm()
    // =================================================================
    
    useEffect(() => {
        loadData();
    }, [id]);
    
    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetById_PeriodLimitation_Api(id);
            setLoading(false);
            if (data.messageStatus === "Successful") {
                const limitData = data.messageData.data;
                setPeriodLimitation(limitData);
                setCategoryId(limitData.categoryId);
                
                // 1. تنظیم مقادیر اولیه برای DatePicker ها
                setInitialFromDate(limitData.from_Shamsi);
                setInitialToDate(limitData.to_Shamsi);

                // 2. تنظیم مقادیر فرم (شامل فیلدهای متنی و عددی)
                // توجه: مقادیر from_Shamsi و to_Shamsi نیز برای Form.Item تنظیم می‌شوند
                form.setFieldsValue(limitData);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            const updatedValues = {
                ...values,
                // ارسال categoryId از State به جای Form.Item
                categoryId: categoryId, 
            };

            let data = await Update_PeriodLimitation_Api(updatedValues);
            setLoading(false);

            if (data.messageStatus === "Successful") {
                showMessage(data.message, "Successful")
                rowUpdated();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        // رفع مشکل: تبدیل آبجکت خطا به رشته قبل از ارسال به showMessage
        const errorFields = errorInfo.errorFields;
        let errorMessage = "خطا در تکمیل فرم. فیلدهای زیر مشکل دارند: \n";
        
        if (errorFields && errorFields.length > 0) {
            errorFields.forEach(field => {
                const fieldName = field.name.join(' '); 
                const fieldErrors = field.errors.join(' | '); 
                errorMessage += `\n ${fieldName}: ${fieldErrors}`;
            });
        } else {
             errorMessage = "خطا در تکمیل فرم: " + JSON.stringify(errorInfo);
        }

        showMessage(errorMessage, "error");
    };
    // =================================================================
    
    return (
        <>
            {periodLimitation ? (
                <>
                    <div className='sectionTitle'>
                        <h2 >
                            ویرایش {periodLimitation.title}
                        </h2>
                    </div>

                    <div className='container'>
                        <Form
                            name="basic"
                            form={form}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 20 }}
                            onFinish={onSubmit}
                            onFinishFailed={onFinishFailed}
                        >
                            <Form.Item name="id" hidden={true} />
                            <Form.Item name="periodId" hidden={true} />

                            <Form.Item
                                name="title"
                                label="عنوان"
                                rules={[{ required: true, message: 'لطفاً عنوان را وارد کنید!' }]}
                            >
                                <Input placeholder='عنوان' />
                            </Form.Item>

                            <Form.Item
                                name="comment"
                                label="شرح"
                                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                            >
                                <Input placeholder='شرح' />
                            </Form.Item>

                            {/* DatePicker ها */}
                            <Form.Item
                                name="from_Shamsi"
                                label="از تاریخ"
                                rules={[{ required: true, message: 'لطفاً تاریخ شروع را انتخاب کنید!' }]}
                            >
                                <PersianDatePickerAdapter 
                                    value={initialFromDate} 
                                />
                            </Form.Item>

                            <Form.Item
                                name="to_Shamsi"
                                label="تا تاریخ"
                                rules={[{ required: true, message: 'لطفاً تاریخ پایان را انتخاب کنید!' }]}
                            >
                                <PersianDatePickerAdapter 
                                    value={initialToDate}
                                />
                            </Form.Item>
                            
                            {/* **حذف اتصال نام فیلد (name) از Form.Item برای AllCategoryComponent** */}
                            <Form.Item
                                label="محدودیت برای گروه"
                                // name حذف شد تا Ant Design آن را اجباری نبیند
                                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                            >
                                <AllCategoryComponent
                                    setLoading={setLoading}
                                    showMessage={showMessage}
                                    parentId={-1}
                                    isShowAddSubCategory={false}
                                    isShowEdit={false}
                                    isShowDelete={false}
                                    isLoadObjectInstanceCategories={false}
                                    isLoadCategoryFromParam={true}
                                    selectedCategory={categoryId}
                                    isShowCheckBox={true}
                                    // مقدار انتخاب شده را مستقیماً در State ذخیره می‌کند
                                    onCheckChange={(catId, checked) => { if (checked) setCategoryId(catId); }}
                                />
                            </Form.Item>


                            <Form.Item
                                name="isForAll"
                                label="محدودیت همراهان"
                                valuePropName='checked'
                            >
                                <Checkbox ></Checkbox>
                            </Form.Item>

                            <Form.Item
                                name="orderIndex"
                                label="ترتیب"
                            >
                                <InputNumber />
                            </Form.Item>


                            <Form.Item
                                name="isActive"
                                label="فعال"
                                valuePropName='checked'
                            >
                                <Checkbox ></Checkbox>
                            </Form.Item>


                        </Form>
                    </div>
                    <Row className='sectionFooter'>
                        <Col xs={0} sm={0} md={8} lg={16} xl={16} />
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                style={{ width: '98%' }}
                                className='btn-primary'
                                htmlType="submit"
                                onClick={() => form.submit()}>
                                <CheckOutlined />
                                ذخیره
                            </Button>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                className='btn-secondary'
                                style={{ width: '100%' }}
                                onClick={() => cancelEdit()}>
                                <RollbackOutlined />
                                لغو </Button>
                        </Col>
                    </Row>
                </>
            )
                : (<></>)}
        </>
    )
}